import { Image, Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import PremiumProductOptionsSimple, { COMPONENT_SECTION_CONTEXT } from '../PremiumProductOptionsSimple';

import PremiumBadge from '../../images/premium-badge.png';

import { StyledBg, StyledContentContainer } from '../StyledComponents/StyledLayout';

import { StyledPremiumBadgeContainer } from './StyledComponents';

const PremiumUpsell = () => {
  return (
    <StyledBg isFluidBg={true} backgroundColor="blue100" data-testid="PremiumUpsell">
      <StyledContentContainer maxWidth={375}>
        <Spacer paddingTop={5} paddingBottom={10}>
          <StyledPremiumBadgeContainer>
            <Image src={PremiumBadge} alt="premium badge" width={107} />
          </StyledPremiumBadgeContainer>

          <Spacer marginBottom="xs" />

          <Text textStyle="heading-xs" asChild css={{ marginBottom: '200' }}>
            <p>Get the most out of your listing with premium</p>
          </Text>
          <Text asChild>
            <p>
              Get up to 3x more views on your listing and gain access to deeper insights and analytics to help you price
              your rental and optimize your listing.
            </p>
          </Text>

          <PremiumProductOptionsSimple componentSectionContext={COMPONENT_SECTION_CONTEXT.BOTTOM} />
        </Spacer>
      </StyledContentContainer>
    </StyledBg>
  );
};

export default PremiumUpsell;
